import React from "react";
import MinimizedTooltip from "../tooltip/MinimizedTooltip";
import { PendingAssetClientInfDto } from "@growth-machine-llc/stridist-api-client";
import { Avatar } from "../avatar/Avatar";

interface IPendingAvatarWithTooltipProps {
  pendingAssetClientInfo: PendingAssetClientInfDto;
}

const PendingAvatarWithTooltip = (props: IPendingAvatarWithTooltipProps) => {
  const { pendingAssetClientInfo } = props;
  return (
    <MinimizedTooltip
      title={
        <>
          Exercise suggestion from {""}
          <b>{pendingAssetClientInfo?.clientName}</b>
        </>
      }
      placement="top-start"
      opacity={0.8}
      isExerciseLibrary
    >
      <Avatar
        photoURL={pendingAssetClientInfo?.photoUrl}
        displayName={pendingAssetClientInfo?.clientName}
        usePendingExerciseAvatarStyle={true}
      />
    </MinimizedTooltip>
  );
};

export default PendingAvatarWithTooltip;
